const AllCustomers = () => {
	return <div>AllCustomers</div>;
};

export default AllCustomers;
